import React, { useState, useEffect } from "react";

import ReportLayout from "../components/ReportLayout";
import { DateField } from "../components/DateField";
import { SelectField } from "../components/SelectField";

import API_BASE_URL from "../utilities/ApiConfig";
import axios from "axios";

export default function SpotInspection() {
  const [form, setForm] = useState({
    report: "",
    district: "",
    year: "",
    month: "",
  });
  const [districts, setDistricts] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/Master/get_District_Mas`)
      .then((res) => setDistricts(res.data.data));
  }, []);

  const handleChange = (field) => (e) =>
    setForm((f) => ({ ...f, [field]: e.target.value }));
  const handleDownload = () => console.log(form);

  return (
    <ReportLayout title="Spot Inspection" onDownload={handleDownload}>
      <SelectField
        id="report"
        label="Report Type"
        value={form.report}
        onChange={handleChange("report")}
        options={[
          { value: "revenue", label: "Revenue Comparison" },
          { value: "documents", label: "Document Count" },
          { value: "top-deeds", label: "Top Deeds" },
        ]}
      />
      <SelectField
        id="district"
        label="Select District"
        value={form.district}
        onChange={handleChange("district")}
        options={districts.map((d) => ({
          value: d.dcode,
          label: d.districtName,
        }))}
      />

      <DateField
        id="year"
        label="Year"
        value={form.year}
        onChange={handleChange("year")}
      />
      <DateField
        id="month"
        label="Month"
        value={form.month}
        onChange={handleChange("month")}
      />
    </ReportLayout>
  );
}
